$(document).ready(function () {

  $(".ss-carousel").each(function (index) {
    let loopMode = false;
    if ($(this).attr("loop-mode") === "true") {
    loopMode = true;
  }
    let sliderDuration = 300;
    let slidesPerView = 3;
    let attr = $(this).attr('slidesPerView');
    if (attr) {
      slidesPerView = attr;
    }

    const swiper = new Swiper($(this).find(".swiper")[0], {
      speed: sliderDuration,
      loop: loopMode,
      autoHeight: false,
      centeredSlides: false,
      followFinger: true,
      freeMode: false,
      slideToClickedSlide: false,
      slidesPerView: 1,
      spaceBetween: "4%",
      rewind: false,
      mousewheel: {
        forceToAxis: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      breakpoints: {
        // mobile landscape
        480: {
          slidesPerView: 1,
          spaceBetween: "4%"
        },
        // tablet
        768: {
          slidesPerView: 2,
          spaceBetween: "4%"
        },
        // desktop
        992: {
          slidesPerView: slidesPerView,
          spaceBetween: "3%"
        }
      },
      navigation: {
        nextEl: $(this).find(".swiper-next")[0],
        prevEl: $(this).find(".swiper-prev")[0],
      },
      slideActiveClass: "is-active",
      slideDuplicateActiveClass: "is-active"
    });

    console.log('Swiper initialized:', swiper);
  });
});
